import React, { useState, useContext } from "react";
import BedInfo from "./components/BedInfo";
import CapacityInfo from "./components/CapacityInfo";
import Amenities from "./components/Amenities/Amenities";
import { ItemInfoWrapper } from "../../container/Styles/Wrappers";
import { AppContext } from "../../context";
import styled from "styled-components";
import TableWrapper from "../../components/Card/StyleWrappers";
import { truncate } from "../../library/text";
import "../../components/Card/Card.css";
import Modal from "antd/lib/modal/Modal";
import SmallModal from "../../components/SmallModal/SmallModal";
import { Popover, Button } from "antd";
import RoomInfo from "./RoomInfo";
import Typology from "./components/Typology";

function RoomCardContent({ product, context }) {
  const [isPriceModalVisible, setIsPriceModalVisible] = useState(false);
  let info = useContext(AppContext);

  const popoverContent = (
    <div style={{ padding: 10 }}>
      <p>{product.request}</p>
    </div>
  );

  const selectComponent = () => {
    switch (context) {
      case undefined:
        return (
          <div className="card-body">
            <div className="ahp-room-indicators">
              {product.lod_room_type && (
                <div className="ahp-room-category-indicators">
                  <Typology room_type={product.lod_room_type} t={info.t} />
                </div>
              )}
              <div className="ahp-room-category-indicators">
                <CapacityInfo
                  adults={product.lod_capacity_adults}
                  children={product.lod_capacity_children}
                />
              </div>
              <div className="ahp-room-category-indicators">
                <BedInfo beds={product.lod_beds} />
              </div>
            </div>
            <div className="ahp-description" style={{ marginTop: 16 }}>
              {product.gen_description &&
                truncate(
                  product.gen_description[info.language]
                    ? product.gen_description[info.language]
                    : info.t("portugueseDescription") +
                        " " +
                        (product.gen_description["pt"] ||
                          product.gen_description["pt-pt"]),
                  140,
                  true
                )}
            </div>
          </div>
        );
      case "cart":
      case "reservation":
      case "ticket":
      case "reservation-info":
      case "payment":
        return (
          <div>
            <div className="ahp-reservation-content">
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Check-in</div>
                <div className="ahp-reservation-value">
                  {/* if the context is "reservation-info" the product isn't yet saved in the database
                    so the context variable info is read instead
                  */}

                  {context === "reservation-info"
                    ? // toISOString has a keepOffset boolean parameter. If not set to 'true', it will use UTC time in the conversion
                      info.lodge.checkIn.toISOString(true).split("T")[0]
                    : product.check_in}
                </div>
              </div>
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Check-out</div>
                <div className="ahp-reservation-value">
                  {context === "reservation-info"
                    ? // toISOString has a keepOffset boolean parameter. If not set to 'true', it will use UTC time in the conversion
                      info.lodge.checkOut.toISOString(true).split("T")[0]
                    : product.check_out}
                </div>
              </div>
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">{info.t("rooms")}</div>
                <div className="ahp-reservation-value">
                  {context === "reservation-info"
                    ? info.lodge.rooms
                    : product.quantity}
                </div>
              </div>
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">{info.t("adults")}</div>
                <div className="ahp-reservation-value">
                  {context === "reservation-info"
                    ? info.lodge.adults
                    : product.adults}
                </div>
              </div>
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">
                  {info.t("children")}
                </div>
                <div className="ahp-reservation-value">
                  {context === "reservation-info"
                    ? info.lodge.children
                    : product.children}
                </div>
              </div>
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">{info.t("price")}</div>
                <div className="ahp-reservation-value">
                  {product.gen_price || product.total_price} €
                </div>
              </div>
              {context !== "reservation-info" && product.request && (
                <div className="ahp-reservation-notes">
                  <Popover
                    content={popoverContent}
                    title="Notas"
                    trigger="click"
                  >
                    <a role="button" tabindex="0">
                      {info.t("notes")}
                    </a>
                  </Popover>
                </div>
              )}
            </div>
          </div>
        );
      default:
        return <div></div>;
    }
  };

  return (
    <>
      {context !== "ticket" &&
        context !== "reservation-info" &&
        context !== "payment" &&
        !(
          product.status === "not-available" || product.status == "not-defined"
        ) && (
          <div className="ahp-price">
            <div className="ahp-price-value">
              {product.gen_price || product.total_price} €
            </div>
            <div
              className="ahp-price-info"
              onClick={() => setIsPriceModalVisible(true)}
            >
              i
            </div>
          </div>
        )}
      {selectComponent()}
      <SmallModal
        text="Preço de toda a reserva, para o número de quartos e datas selecionadas."
        isPriceModalVisible={isPriceModalVisible}
        setIsPriceModalVisible={setIsPriceModalVisible}
      />
    </>
  );
}

export default RoomCardContent;
